import { defineComponent as _defineComponent } from 'vue'
import { useEnglishResumeFormatData } from '@/composables/format-edit/useEnglishResumeFormatData'


export default /*#__PURE__*/_defineComponent({
  __name: 'EnglishResumeProfileCard',
  props: {
    currentCardId: null
  },
  setup(__props: any) {



const formatData = useEnglishResumeFormatData()

return { __sfc: true,formatData }
}

})